<!-- =========================================================================================
  File Name: TeacherView.vue
  Description: Teacher View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="teacher-view-tab-info">
    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="mb-4 vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <img :src="teacher_data.photo" class="mr-8 rounded h-24 w-24" />
          <!-- <vs-avatar :src="data.avatar" size="80px" class="mr-4" /> -->
          <div>
            <p class="text-lg font-medium mb-2 mt-4" sm:mt-0>{{ teacher_data.name  }}({{ teacher_data.teacherID  }})</p>
            <!-- <input type="file" class="hidden" ref="update_avatar_input" @change="update_avatar" accept="image/*"> -->

            <!-- Toggle comment of below buttons as one for actual flow & currently shown is only for demo -->
            <!-- <vs-button class="mr-4 mb-4">변경</vs-button> -->
            <!-- <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()">Change Avatar</vs-button> -->

            <!-- <vs-button type="border" color="danger">삭제</vs-button> -->
            <div class="vx-row">
              <vs-button class="mr-4 mb-4 ml-4" icon-pack="feather" icon="icon-edit" :to="{name: 'teacher-edit', params: { teacherID: $route.params.teacherID }}">수정</vs-button>
              <!-- <vs-button type="border" class="mb-4" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">퇴교</vs-button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <table>
          <tr>
            <td class="font-semibold">휴대폰번호</td>
            <td>{{ teacher_data.mobilephone }}</td>
          </tr>
          <tr>
            <td class="font-semibold">전화번호</td>
            <td>{{ teacher_data.telephone }}</td>
          </tr>
          <tr>
            <td class="font-semibold">주민등록번호</td>
            <td>{{ teacher_data.realJumin }}</td>
          </tr>
          <tr>
            <td class="font-semibold">생년월일</td>
            <td>{{ teacher_data.birthDay }} ({{ isLunar }}) ({{ gender }})</td>
          </tr>
          <tr>
            <td class="font-semibold">이메일</td>
            <td>{{ teacher_data.eMail }}</td>
          </tr>
          <tr>
            <td class="font-semibold">우편번호</td>
            <td>{{ teacher_data.zipCode }}</td>
          </tr>
          <tr>
            <td class="font-semibold">주소</td>
            <td>{{ teacher_data.zipName }}</td>
          </tr>
          <tr>
            <td class="font-semibold">주소세부</td>
            <td>{{ teacher_data.zipDetail }}</td>
          </tr>
        </table>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <table>
          <!-- <tr>
            <td class="font-semibold">Class 정보</td>
            <td>{{ teacher_data.classSeq }}</td>
          </tr> -->
          <tr>
            <td class="font-semibold">소속</td>
            <td>{{ teacher_data.intituteName }}</td>
          </tr>
          <tr>
            <td class="font-semibold">주요경력</td>
            <td>{{ teacher_data.majorCareer }}</td>
          </tr>
          <tr>
            <td class="font-semibold">교사경력</td>
            <td>{{ teacher_data.teacherCareer }}</td>
          </tr>
          <tr>
            <td class="font-semibold">졸업학교</td>
            <td>{{ teacher_data.university }}</td>
          </tr>
          <tr>
            <td class="font-semibold">전공</td>
            <td>{{ teacher_data.subject }}</td>
          </tr>
          <tr>
            <td class="font-semibold">교직원 타입</td>
            <td>{{ teacher_data.userType }}</td>
          </tr>
          <tr>
            <td class="font-semibold">등록일</td>
            <td>{{ teacher_data.createDate }}</td>
          </tr>
        </table>
      </div>
    </div>
    <!-- Save&Delete Button -->
    <!-- <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex flex-wrap items-center justify-end">
          <vs-button icon-pack="feather" icon="icon-edit" class="mr-2" :to="{name: 'teacher-edit', params: { teacherID: $route.params.teacherID }}">수정</vs-button>
          <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">퇴교</vs-button> 
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { putData } from '@/api/module'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      teacher_data: JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isLunar () {
      if (this.teacher_data.isLunar === 0) {
        return '양력'
      } else {
        return '음력'
      }
    },
    gender () {
      if (this.teacher_data.gender === 0) {
        return '남'
      } else {
        return '여'
      }
    },
    status () {
      if (this.teacher_data.status === 0) {
        return '정상'
      } else {
        return '탈퇴'
      }
    }
  },
  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '탈퇴 처리',
        text: `"${this.teacher_data.teacherID} (을/를) 탈퇴 처리하시겠습니까?"`,
        accept: this.deleteRecord,
        acceptText: '탈퇴'
      })
    },
    async deleteRecord () {
      try {
        const teacherData = {
          status: 1,
          teacherID: this.teacher_data.teacherID
        }
        const {data} = await putData('teacher/status', teacherData)
        console.log(data)
        this.$router.push('/teacher/teacher-list')
        this.showDeleteSuccess()

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '탈퇴 처리',
        text: '탈퇴 처리 되었습니다.'
      })
    }
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-teacher-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
